<template>
  <WsMain>
    <WsCRUD
      isFetchBreadCrumbsName
      :label="'相關連動公版'"
      :subLabel="'法規'"
      :modelName="modelName"
      :id="$route.params.id"
      :isBreadCrumbsShow="true"
      :titleKey="'text'"
      :fields="fields"
      :showFields="showFields"
      :showExpand="false"
      :pageMode="true"
      :inRowBtnUpdate="false"
      :inRowBtnDelete="false"
      :rowClickRead="true"
      :isCreatable="false"
      :isVtabsShow="true"
      :tabFields="tabFields"
      :filterSelects="filterSelects"
      :filterProps="filterProps"
      :preTabValue="tabFields[0].value"
      :customUrlParams="customUrlParams"
      @filter-select="$_onFilterSelect($event)"
    >
    </WsCRUD>
  </WsMain>
</template>

<script>
import model from "@/models/act";
// import submodel from "@/models/act_related_template"
export default {
  data(){
    return {
      modelName: model.modelName,
      fields: model.fields,
      showFields: [
        "name",
        "exclusive_factories",
        "updated_admin",
        "updated_at",
      ],
      filterSelects: [
        {
          type: "select",
          label: "",
          modelName: "range_type",
          placeholder: "篩選適用範圍類型",
          textKey: "name",
          items: [
            {
              text: "所有類型",
              value: "",
            },
            {
              text: "通用",
              value: "general",
            },
            {
              text: "專屬",
              value: "exclusive",
            },
          ],
          defaultValue: "",
        },
        {
          type: "hasMany",
          label: "",
          modelName: "factory",
          paramName: "exclusive_factories",
          placeholder: "篩選專屬工廠",
          textKey: "name",
          getText(item) {
            return this.$_CMS_getFactoryName(item)
          },
        },
        {
          type: "hasMany",
          label: "",
          modelName: "factory",
          paramName: "factories",
          placeholder: "篩選適用工廠",
          textKey: "name",
          getText(item) {
            return this.$_CMS_getFactoryName(item)
          },
        },
      ],
      filterProps: {},
      tabFields: [
        {
          text: "證照公版",
          value: "license_template"
        },
        {
          text: "內訓公版",
          value: "internal_training_template"
        },
        {
          text: "點檢表公版",
          value: "checklist_template"
        },
        {
          text: "稽核表公版",
          value: "audit_template"
        },
        {
          text: "承攬商資格證",
          value: "contractor_license_template"
        },
      ],
      customUrlParams: {
          "act_versions" : this.$route.params.version_id
      }
    }
  },
  methods:{
    $_onFilterSelect($event){
      this.filterProps = {
        ...$event,
      };
    }
  }
}
</script>